var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-6" }, [
    _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.question))]),
    _c(
      "div",
      [
        _c("v-textarea", {
          attrs: { outlined: "", autofocus: _vm.autofocus },
          on: { keyup: _vm.changed },
          model: {
            value: _vm.response,
            callback: function($$v) {
              _vm.response = $$v
            },
            expression: "response"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }